export const environment = {
  production: true,
  serviceUrl: '/api'
};
